import { render, staticRenderFns } from "./SubscriptionList.vue?vue&type=template&id=671f0a5f"
import script from "./SubscriptionList.vue?vue&type=script&lang=js"
export * from "./SubscriptionList.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionList.vue?vue&type=style&index=0&id=671f0a5f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports